import request from "../utils/request";

// export function lotteryDetail(params) {
//   return request({
//     url: '/lottery/detail',
//     method: 'GET',
//     params: params
//   })
// }

// export function lotteryDraw(data) {
//   return request({
//     url: '/lottery/draw',
//     method: 'post',
//     data: data,
//   })
// }
// 使用cookies登录
export function autologin(data) {
  return request({
    url: '/user/autologin',
    method: 'post',
    data: data
  })
}
// 获取渠道
export function getChannelId(params) {
  return request({
    url: '/channel/uid',
    method: 'GET',
    params: params
  })
}

// 任务分类
export function floattaskCate(data) {
  return request({
    url: '/float/taskCate',
    method: 'get',
    params: data,
  })
}

// 任务列表
export function floattaskList(data) {
  return request({
    url: '/float/taskList',
    method: 'get',
    params: data,
  })
}

// 区服
export function floatserverLists(data) {
  return request({
    url: '/float/serverLists',
    method: 'get',
    params: data,
  })
}

// 交易列表
export function floattradeList(data) {
  return request({
    url: '/float/tradeList',
    method: 'get',
    params: data,
  })
}

// 消息列表
export function floattmessageList(data) {
  return request({
    url: '/float/messageList',
    method: 'get',
    params: data,
  })
}

// 已读消息
export function floatmessageRead(data) {
  return request({
    url: '/float/messageRead',
    method: 'post',
    data: data,
  })
}

// 优惠券列表
export function floatcouponList(data) {
  return request({
    url: '/float/couponList',
    method: 'get',
    params: data,
  })
}

// 一键领取优惠券
export function couponbatchReceive(data) {
  return request({
    url: '/home/coupon/batchReceive',
    method: 'post',
    data: data,
  })
}

// 领取优惠券
export function couponreceive(data) {
  return request({
    url: '/home/coupon/receive',
    method: 'post',
    data: data,
  })
}

// 礼包列表
export function floatgiftList(data) {
  return request({
    url: '/float/giftList',
    method: 'get',
    params: data,
  })
}

// 领取礼包
export function giftreceive(data) {
  return request({
    url: '/home/gift/bag/receive',
    method: 'post',
    data: data,
  })
}

// 资讯列表
export function floatnewsList(data) {
  return request({
    url: '/float/newsList',
    method: 'get',
    params: data,
  })
}

// 修改昵称
export function nickname(data) {
  return request({
    url: '/home/update/user/nick/name',
    method: 'post',
    data: data,
  })
}

// 发送验证码
export function smssend(data) {
  return request({
    url: '/sms/send',
    method: 'post',
    data: data,
  })
}

// 修改密码
export function editPassword(data) {
  return request({
    url: '/home/update/editPassword',
    method: 'post',
    data: data,
  })
}

// 解绑手机
export function unbindmobile(data) {
  return request({
    url: '/home/update/unbindmobile',
    method: 'post',
    data: data,
  })
}

// 绑定手机
export function bindmobile(data) {
  return request({
    url: '/home/update/bindmobile',
    method: 'post',
    data: data,
  })
}

// 实名认证
export function realname(data) {
  return request({
    url: '/home/update/realname',
    method: 'post',
    data: data,
  })
}

// 充值记录
export function orderlist(data) {
  return request({
    url: '/home/order/list',
    method: 'get',
    params: data,
  })
}

// 代金券记录
export function gamecouponlist(data) {
  return request({
    url: '/home/gamecoupon/list',
    method: 'get',
    params: data,
  })
}

// 平台币充值
export function walletcharge(data) {
  return request({
    url: '/home/wallet/charge',
    method: 'post',
    data: data,
  })
}

// 小号列表
export function floatxiaohao(data) {
  return request({
    url: '/float/xiaohao',
    method: 'get',
    params: data,
  })
}

// 添加小号
export function floataddxiaohao(data) {
  return request({
    url: '/float/addxiaohao',
    method: 'post',
    data: data,
  })
}

// 修改昵称或设置默认
export function floatupdateXiaohao(data) {
  return request({
    url: '/float/updateXiaohao',
    method: 'post',
    data: data,
  })
}